<template>
  <div class="content-container">
    <div v-for="(firstLevel, index) in treeData" :key="firstLevel.id" class="first-level-item">
      <div class="header">
        <img :class="{ opened: isSecondLevelOpen[firstLevel.id] }" :src="firstLevel.children.length ? arrow : disabled"
          @click="toggleSecondLevel(firstLevel.id, firstLevel)" />
        <span @click="handleTree(firstLevel, 1)">{{ firstLevel.name }}</span>
      </div>
      <div v-if="isSecondLevelOpen[firstLevel.id]" class="second-level-items">
        <div v-for="(secondLevel, subIndex) in firstLevel.children" :key="subIndex" class="second-level-item">

          <div v-if="styleTemplate === 'zzWangji'">
            <div class="header">
              <img @click="toggleSecondLevel(secondLevel.id, secondLevel)"
                :class="{ opened: isSecondLevelOpen[secondLevel.id] }"
                :src="secondLevel.children.length ? arrowTwo : ''" mode="aspectFit"></img>
              <span @click="handleTree(secondLevel, 2)">{{ secondLevel.name }}</span>
            </div>

            <div v-if="isSecondLevelOpen[secondLevel.id]" class="second-level-items">
              <div v-for="(threeLevel) in secondLevel.children" wx:key="*this" class="second-level-item three-level-item">
                <span @click="handleTree(threeLevel, 3)">{{ threeLevel.name }}</span>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="header">
              <span @click="handleTree(secondLevel, 2)">{{ secondLevel.name }}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { judgmentPlatform, isEbookShowUpdateToast, goApp } from '@/utils/tools';

export default {
  props: {
    buyStatus: {
      type: Array,
      default: () => [],
    },
    treeData: {
      type: Array,
      default: () => [],
    },
    productDetail: {
      type: Object,
      default: () => { },
    },
    styleTemplate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      isSecondLevelOpen: {},
      arrow: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/down.png',
      disabled: 'https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/eBook/book_cate_disabled.png',

      arrowTwo: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/tree21_up.png'

    };
  },
  created() {
    // this.treeData.forEach(() => {
    //   this.isSecondLevelOpen.push(false);
    // });
  },
  methods: {
    toggleSecondLevel(id, firstLevel) {
      if (!firstLevel?.children.length) return;
      this.isSecondLevelOpen[id] = !this.isSecondLevelOpen[id];
      const temp = this.isSecondLevelOpen;
      this.isSecondLevelOpen = JSON.parse(JSON.stringify(temp));
    },
    handleTree(info, level) {
      if (!this.buyStatus.length) return;
      const { bookId, id, contentId, parentId } = info;
      if (this.isApp) {
        if (judgmentPlatform() === 'HarmonyOS') {
          this.$toast('当前设备不支持，请更换ios/Android最新版学习');
        } else if (isEbookShowUpdateToast(this.styleTemplate)) {
          this.$toast('请更新最新版查看该电子书');
        } else {
          let params = {
            userProductId: this.buyStatus?.[0]?.id,
            chapterId: id,
            styleTemplate: this.styleTemplate,
          };
          if (this.styleTemplate === 'english' && level === 2) {
            params.chapterId = parentId;
            params.contentId = contentId;
          }
          if (this.styleTemplate === 'zzWangji' && level === 3) {
            params.chapterId = parentId
            params.contentId = contentId;
          }
          this.$sendToApp('goEBookReadingPage', params, false);
        }
      } else if (this.miniprogram) {
        let toId = id

        if (this.styleTemplate === 'zzWangji' && level === 3) {
          toId = parentId
        }

        let url = `/eBook/eBookRead/eBookRead?bookId=${bookId}&productId=${this.productDetail.productId}&openCourseId=${this.buyStatus?.[0]?.id}&styleTemplate=${this.styleTemplate}&chapterId=${toId}&paragraphId=${contentId}&anchor=top`;
        wx.miniProgram.navigateTo({
          url, // 这里需要填写实际的跳转页面路径
        });
      } else if (goApp()) {
        this.$toast('请前往启航教育app体验');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.first-level-item {
  margin-bottom: 10px;
  border-radius: 5px;
}

.header {
  display: flex;
  align-items: center;
  min-height: 94px;
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
  }

  .opened {
    transform: rotate(180deg);
  }

  span {
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 38px;
  }
}

.second-level-items {
  padding-left: 48px;

  .second-level-item {
    // padding: 29px 0;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
  }
}

.three-level-item {
  padding: 29px 0;
}
</style>
